import { Link } from 'react-router-dom';
import { productServices } from '@/mocks/clsqData';

export default function ProductServicesSection() {
  const featuredProducts = productServices.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100/80 text-accent-700 rounded-full text-xs font-medium mb-4">
            产品与服务
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            全方位产品矩阵
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            从智能解决方案到专业技术支持，clsq为您提供一站式的产品与服务体验
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-product-shop>
          {featuredProducts.map((product) => (
            <Link
              key={product.id}
              to="/categories"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {product.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {product.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {product.features.map((f) => (
                    <span
                      key={f}
                      className="px-2.5 py-1 bg-secondary-100/80 text-secondary-700 rounded-md text-xs font-medium"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-md text-sm font-medium hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部产品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}